import { isValid, parse } from "date-fns";
import { FieldPath } from "react-hook-form";
import { AddCaseProps } from "src/pages/addCase/types";

export const getPracDetails = (
  fieldName: string,
  is_anesthesiologist: boolean
): {
  inputLabel: string;
  inputPlaceholder: string;
  linkTitle: string;
  doctorField: FieldPath<AddCaseProps> | null;
} => {
  if (fieldName.includes("treating_prac")) {
    return {
      inputLabel: "Treating Facility",
      inputPlaceholder: "Select Treating Facility...",
      linkTitle: "New Treating Facility",
      doctorField: "doctor_attributes.treating_doctor_id",
    };
  } else if (fieldName.includes("treating_doc")) {
    if(is_anesthesiologist) {
      return {
        inputLabel: "Treating Provider",
        inputPlaceholder: "Select Treating Provider, or if unknown, Select Treating Facility...",
        linkTitle: "New Treating Facility",
        doctorField: null,
      };
    } else {
      return {
        inputLabel: "Treating Provider",
        inputPlaceholder: "Select Treating Provider, or if unknown, Select Treating Facility...",
        linkTitle: "New Treating Facility",
        doctorField: null,
      };
    }
  } else {
    return {
      inputLabel: "Referring Facility",
      inputPlaceholder: "Select Referring Facility...",
      linkTitle: "New Referring Facility",
      doctorField: "doctor_attributes.referring_doctor_id",
    };
  }
};

export const getDocDetails = (
  fieldName: string,
  isPracUser: boolean
): { inputLabel: string; inputPlaceholder: string; linkTitle: string } => {
  if (fieldName.includes("treat")) {
    return {
      inputLabel: "Treating Provider",
      inputPlaceholder: isPracUser ? "Select Treating Provider, or if unknown, Select Treating Facility..." : "Select Treating Provider...",
      linkTitle: "New Treating Provider",
    };
  } else {
    return {
      inputLabel: "Referring Provider",
      inputPlaceholder: "Select Referring Provider...",
      linkTitle: "New Referring Provider",
    };
  }
};

export function detectDateFormat(dateString: string) {
  // Extend this list with the formats you expect
  const possibleFormats = [
    "yyyy-MM-dd",
    "dd/MM/yyyy",
    "MM/dd/yyyy",
    "dd-MM-yyyy",
    "MM-dd-yyyy",
    "yyyy/MM/dd",
    "dd MMM yyyy",
    "MMM dd, yyyy",
  ];

  for (const fmt of possibleFormats) {
    try {
      const parsed = parse(dateString, fmt, new Date());
      // If parsing succeeded and returned a valid Date
      if (isValid(parsed)) {
        return fmt;
      }
    } catch (err) {
      // ignore failed format
    }
  }

  return null; // No matching format found
}
